module.exports = __webpack_public_path__ + "static/media/StandEmpty-8.9048176f.png";